import React from 'react'
import { IRegionTag } from '@cbgms/api'
import { useTranslation } from 'react-i18next'
import { isRequired } from '@cbgms/base/utils/validations'
import { COUNTRYOPTIONS } from 'core/constants/countries'
import { CMSSYSTEMVALUES } from 'core/constants/cmsSystemValues'
import FormikFormLayout, { IDeleteOptions } from 'core/page/layout/FormikFormLayout'
import { Form, FormProps } from '@carsys/form'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { TextField } from '@carsys/form/src/TextField'
import { Dropdown } from '@carsys/form/src/Dropdown'
import { CountriesDropdownFormik } from '@carsys/form/src/CountriesDropdownFormik'
import { useFormikContext } from 'formik'
import { CmsSystem } from '@cbgms/api/modules/enums'

interface Props extends FormProps<IRegionTag, IRegionTag> {
  headerText: string
  deleteOptions?: IDeleteOptions
  form: string
}

const CMSConfig: React.FC<{}> = () => {
  const { t } = useTranslation()
  const { values: formValues } = useFormikContext<IRegionTag>()

  return (
    <Box sx={{ width: '100%', my: 1 }}>
      <Typography variant='h5' sx={{ marginBottom: 1 }}>
        {t('region_tag.cms-config')}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
        <Dropdown
          data-testid='input-cms-system'
          label={t('region_tag.cmsSystem')}
          name='CmsSystem'
          options={CMSSYSTEMVALUES}
          clearButton
          fullWidth={false}
        />
        <TextField data-testid='input-cms-url' label={t('region_tag.cmsURL')} name='CmsURL' fullWidth={false} />
        {!!formValues.CmsSystem && formValues.CmsSystem === CmsSystem.DrupalJSONAPI && (
          <TextField label={t('wholesale.cms_drupal_override')} name='CMSDrupalOverride' fullWidth={false} />
        )}
      </Box>
    </Box>
  )
}

const RegionForm: React.FC<Props> = ({ form, headerText, deleteOptions, ...props }) => {
  const { t } = useTranslation()

  return (
    <Form formID={form} {...props}>
      <FormikFormLayout
        title={<Typography variant='h5'>{t(headerText)}</Typography>}
        backButtonProps={{ to: '/regions' }}
        deleteOptions={deleteOptions}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            flexWrap: 'wrap',
            '&>*': { flex: '1 1 auto' }
          }}
        >
          <TextField
            data-testid='input-region-name'
            label={t('region_tag.name')}
            name='Name'
            required
            validate={isRequired}
            fullWidth={false}
          />
          <CountriesDropdownFormik
            countryOptions={COUNTRYOPTIONS}
            data-testid='input-region-country'
            label={t('region_tag.country')}
            name='Country'
            required
            fullWidth={false}
          />
          <CMSConfig />
        </Box>
      </FormikFormLayout>
    </Form>
  )
}

export default RegionForm
